import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { AddHardphoneModule } from '../add-phone-to-device/add-hardphone.module';
import { AddPhoneComponent } from './containers/add-phone.component';
import { AddPhoneEffects } from './state/add-phone.effects';
import * as fromAddPhone from './state/add-phone.reducer';
import { AddPhoneViewComponent } from './views/add-phone-view.component';

@NgModule({
   declarations: [AddPhoneComponent, AddPhoneViewComponent],
   imports: [
      LcsResponsiveTableModule,
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      AddHardphoneModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatButtonModule,
      MatTooltipModule,
      MatSelectModule,
      MatDialogModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatIconModule,
      EntitySelectModule,
      StoreModule.forFeature(fromAddPhone.addPhoneFeatureKey, fromAddPhone.reducer),
      EffectsModule.forFeature([AddPhoneEffects]),
   ],
})
export class AddPhoneModule {}
